import { CustomField } from "@/backend/models/customFields/customField";
import { useParameterStore } from "@/frontend/store/ParameterStore";
import { I18n } from "@/i18n/I18n";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { CircleX } from "lucide-react";
import { ButtonParent } from "../buttons/ButtonParent";


export function DeleteParameterFieldButton(props: { field: CustomField, fieldCount: number }) {
  const { field, fieldCount } = props;
  const deleteCustomField = useParameterStore(state => state.deleteCustomField);

  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={fieldCount === 1 ? <Tooltip>{I18n.get('cannotDeleteLastItem')}</Tooltip> : <div/>}
    >
      <div>
        <ButtonParent
          className='bg-transparent border-0'
          onClick={() => void deleteCustomField(field)}
          title={I18n.get('deleteValue')}
          disabled={fieldCount === 1}
        >
          <CircleX color='var(--neutral-400)' />
        </ButtonParent>
      </div>
    </OverlayTrigger>
  );
}
